import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";

interface StateInterface {
  isFetching: boolean;
  fields: string[];
  translatedMessage: string;
};

const initialState: StateInterface = {
  isFetching: false,
  fields: [],
  translatedMessage: ""
};

export const unitCreateReducer = (state: StateInterface = initialState, action: ActionInterface): StateInterface => {
  switch (action.type) {
    case Constants.GLOBAL_UNIT_CREATE_REQUEST:
      return {
        ...state,
        isFetching: true
      };

    case Constants.GLOBAL_UNIT_CREATE_SUCCESS:
      return {
        ...state,
        isFetching: false
      };

    case Constants.GLOBAL_UNIT_CREATE_FAILURE:
      return {
        ...state,
        isFetching: false,
        fields: action.payload?.err && action.payload?.err.fields || [],
        translatedMessage: action.payload?.err && action.payload?.err.translatedMessage
      };

    case Constants.GLOBAL_CHARGE_TYPE_CREATE_FAILURE:
    case Constants.GLOBAL_AGENCY_FEE_CREATE_FAILURE:
      return {
        ...state,
       // isFetching: false,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };

    case Constants.GLOBAL_UNIT_CREATE_CLEAR:
    case Constants.GLOBAL_CHARGE_TYPE_CREATE_CLEAR:
    case Constants.AUTH_SIGNOUT:
      return {
        ...initialState
      };

    default:
      return state;
  }
};
